import DashboardMenuStore from "@/common/store/DashboardMenuStore";
import useCache from "@/common/hook/useCache";

export default function useDashboardMenu() {
  return useCache(DashboardMenuStore.KEY);
}
